<template lang="pug">
  section.hero.is-black-ducter(ref="oper" :style="{ backgroundImage: 'url(' + require('@/assets/ducter_small.svg') + ')', repeat: 'repeat' }")
    .container
      .columns.has-text-centered.content
        .column.is-12
          h2.title.is-size-2.has-text-white  Operaciones
      .columns.has-text-centered.is-mobile
        .column.is-12
          .container
            .card-features(ref="termigas")
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  h3.has-text-white.title.is-size-3 Termigas
                  h2.has-text-white.subtitle.is-size-3 Almacenamiento
                  p.has-text-white.paragraph.is-size-4 Almacenamos gas L.P. de la más alta calidad en esferas semi-refrigeradas.
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/f7.jpg')")
            .card-features
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/ship2.jpg')")
                .column
                  h3.has-text-white.title.is-size-3 Termigas
                  h2.has-text-white.subtitle.is-size-3 Almacenamiento
                  p.has-text-white.paragraph.is-size-4 Recibimos buque tanques con gas L.P. importado de otros países.
            .card-features
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  h3.has-text-white.title.is-size-3 Termigas
                  h2.has-text-white.subtitle.is-size-3 Despacho
                  p.has-text-white.paragraph.is-size-4 Despachamos gas L.P. a sitios de toda la república desde nuestra instalación ubicada en el estado de Veracruz.
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/f9.jpg')")
            .card-features(ref="ducto")
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/f10.jpg')")
                .column
                  h3.has-text-white.title.is-size-3 L.P.G Ducto
                  h2.has-text-white.subtitle.is-size-3 Bombeo
                  p.has-text-white.paragraph.is-size-4 Sistema de ductos que cuentan con la más alta tecnología y seguridad.
            .card-features(ref="irge")
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  h3.has-text-white.title.is-size-3 IRGE
                  h2.has-text-white.subtitle.is-size-3 Almacenamiento
                  p.has-text-white.paragraph.is-size-4 Almacenamos gas L.P. proveniente de nuestras instalaciones en el estado de Veracruz.
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/f11.jpg')")
            .card-features
              .columns.reverse-row-order.has-text-centered.is-vcentered
                .column
                  div.is-horizontal-center
                    figure.image.is-600x600
                      img(:src="require('@/assets/f12.jpg')")
                .column
                  h3.has-text-white.title.is-size-3 IRGE
                  h2.has-text-white.subtitle.is-size-3 Despacho
                  p.has-text-white.paragraph.is-size-4 Distribuimos gas L.P. a destinos de toda la república desde nuestras instalaciones en el estado de Hidalgo.
  </template>

<script>
  export default {
    name: 'Operaciones',
    props: {
      seccionSel: {
        type: String,
        default: ''
      },
    },
    watch: {
      seccionSel() {
        switch (this.seccionSel) {
          case 'oper':
            this.$refs['oper'].scrollIntoView({ behavior: 'smooth' })  
            break
          case 'termigas':
            this.$refs['termigas'].scrollIntoView({ behavior: 'smooth' })  
            break
          case 'ducto':
            this.$refs['ducto'].scrollIntoView({ behavior: 'smooth' })  
            break
          case 'irge':
            this.$refs['irge'].scrollIntoView({ behavior: 'smooth' })  
            break
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .hero {
    margin-bottom: 40px !important;
  }
  .container {
    height: 100%;
    margin-bottom: 30px;
  }
  .content {
    margin-top: 30px;
  }
  .is-600x600 {
    max-height: 450px;
    max-width: 450px;
  }
  .is-horizontal-center {
		display: flex !important;
		justify-content: center;
	}

  .is-black-ducter {
    background-color: #000000;
  }
</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/Operaciones.vue